import { message as antdMessage } from "antd";
import type {
  MessageInstance,
  ArgsProps,
  JointContent,
  ConfigOptions,
} from "antd/es/message/interface";

/**
 * Message API - global message notifications
 * Provides methods for success, error, info, warning, and loading messages
 */
export const message: MessageInstance = antdMessage;

export type MessageArgsProps = ArgsProps;
export type MessageContent = JointContent;
export type MessageConfig = ConfigOptions;
export type { MessageInstance };

export default message;
